export default "__VITE_ASSET__Cgs5pUK2__"